import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const FORGOT_PASSWORD_VISIBILITY = new InjectionToken(
  'variable for modal visibility',
  { providedIn: 'root', factory: () => new BehaviorSubject<boolean>(false) },
);
